import { SelectOption } from "../types/select";

export function findSelectOption<TValue>(
  options: SelectOption<TValue>[],
  value: TValue
): SelectOption<TValue> | undefined {
  return options.find((item) => item.value === value);
}
